export default {
	FormType: 'formType',
	FormStep: 'formStep',
	Coach: 'coachTrainer',
	Gender: 'gender',
	Age: 'age',
	BirthYear: 'yearofBirth',
	Height: 'usrHeight',
	Weight: 'usrWeight',
	ActivityGoal: 'usrActivityGoal',
	WeightReduceGoal: 'usrActivityGoalWght',
	ActivityLevel: 'usrActivityFree',
	NutritionPhilosophy: 'usrNutritionTyp',
	Allergies: 'usrIntolerance',
};

export type ConstantsType = {
	Gender: {
		Male: 'm';
		Female: 'f';
	};
	Trainer: {
		Leo: 'LEO';
		Mia: 'MIA';
	};
	ActivityGoal: {
		LooseWeight: string;
		GettingFit: string;
	};
	ActivityFree: {
		Low: string;
		Medium: string;
		High: string;
	};
};

export const Constants: ConstantsType = {
	Gender: {
		Male: 'm',
		Female: 'f',
	},
	Trainer: {
		Leo: 'LEO',
		Mia: 'MIA',
	},
	ActivityGoal: {
		LooseWeight: 'loose weight',
		GettingFit: 'getting fit',
	},
	ActivityFree: {
		Low: 'low',
		Medium: 'medium',
		High: 'high',
	},
};
